'use strict';

var _ = require('lodash');
var MarketProductGroupProfileChartAggregationFactory = function MarketProductGroupProfileChartAggregationFactory(DataAggregationFactory) {
  var AVAILABLE_CURVES_CONFIGS = [{
    curveName: 'bookingCurveCurrentYear',
    metric: 'booking',
    isStringType: false
  }, {
    curveName: 'bookingCurveLastYear',
    metric: 'booking',
    isStringType: false
  }, {
    curveName: 'bookingCurveSeasonalAverage',
    metric: 'booking',
    isStringType: false
  }, {
    curveName: 'minURDBookingCurve',
    metric: 'booking',
    isStringType: false
  }, {
    curveName: 'maxURDBookingCurve',
    metric: 'booking',
    isStringType: false
  }, {
    curveName: 'avgURDBookingCurve',
    metric: 'booking',
    isStringType: false
  }, {
    curveName: 'revenueCurveCurrentYear',
    metric: 'revenue',
    isStringType: false
  }, {
    curveName: 'revenueCurveLastYear',
    metric: 'revenue',
    isStringType: false
  }, {
    curveName: 'revenueCurveSeasonalAverage',
    metric: 'revenue',
    isStringType: false
  }, {
    curveName: 'minURDRevenueCurve',
    metric: 'revenue',
    isStringType: false
  }, {
    curveName: 'maxURDRevenueCurve',
    metric: 'revenue',
    isStringType: false
  }, {
    curveName: 'avgURDRevenueCurve',
    metric: 'revenue',
    isStringType: false
  }];
  function MarketProductGroupProfileChartAggregation() {
    DataAggregationFactory.call(this, 'market-product-group-profile-chart', 'profile-chart');
  }
  MarketProductGroupProfileChartAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  MarketProductGroupProfileChartAggregation.constructor = MarketProductGroupProfileChartAggregation;
  MarketProductGroupProfileChartAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.targetType === targetType && this.sourceType === sourceType;
  };
  MarketProductGroupProfileChartAggregation.prototype.aggregate = function (rawData) {
    var that = this;
    return _.reduce(AVAILABLE_CURVES_CONFIGS, function (result, curveConfig) {
      result[curveConfig.curveName] = that.mergeCurveData(rawData, curveConfig);
      return result;
    }, {});
  };
  return MarketProductGroupProfileChartAggregation;
};
MarketProductGroupProfileChartAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = MarketProductGroupProfileChartAggregationFactory;